import React from 'react';
import { ResumeSection } from './ResumeSection';

interface Props {
  highlights: string[];
}

export function EngineeringHighlights({ highlights }: Props) {
  if (!highlights.length) return null;

  return (
    <ResumeSection title="Engineering Highlights">
      <ul className="resume-highlight-list">
        {highlights.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    </ResumeSection>
  );
}
